import type { LanguageName, LanguageSlug } from '~/types'

export type { LanguageName, LanguageSlug }
export type Language = {
  id: number
  name: LanguageName
  slug: LanguageSlug
  /** ASCII route segment (course paths' `langSlug`), e.g. "hiszpanski" for "hiszpański" */
  langSlug: string
  link: string
  flag: string
}

export const languages: Record<LanguageName, Language> = {
  angielski: {
    id: 1,
    name: 'angielski',
    slug: 'english',
    langSlug: 'angielski',
    link: '/kursy?language=english',
    flag: 'uk'
  },
  niemiecki: {
    id: 2,
    name: 'niemiecki',
    slug: 'german',
    langSlug: 'niemiecki',
    link: '/kursy?language=german',
    flag: 'de'
  },
  hiszpański: {
    id: 3,
    name: 'hiszpański',
    slug: 'spanish',
    langSlug: 'hiszpanski',
    link: '/kursy?language=spanish',
    flag: 'es'
  },
  włoski: {
    id: 4,
    name: 'włoski',
    slug: 'italian',
    langSlug: 'wloski',
    link: '/kursy?language=italian',
    flag: 'it'
  }
}

export const languagesBySlug: Record<LanguageSlug, Language> = Object.fromEntries(
  Object.values(languages).map((lang) => [lang.slug, lang])
) as Record<LanguageSlug, Language>

export const languagesByLangSlug: Record<string, Language> = Object.fromEntries(
  Object.values(languages).map((lang) => [lang.langSlug, lang])
)

export type PurposeName =
  'standard' | 'certificate' | 'maturityExam' | 'conversation' | 'kids' | 'individual'
export type Purpose = {
  id: number
  value: PurposeName
  label: string
}

/** Declaration order is the chip order on /kursy (see the course mockups). */
export const purposes: Record<PurposeName, Purpose> = {
  standard: { id: 1, label: 'Standardowy', value: 'standard' },
  conversation: { id: 2, label: 'Konwersacyjny', value: 'conversation' },
  maturityExam: { id: 3, label: 'Maturalny', value: 'maturityExam' },
  certificate: { id: 4, label: 'Certyfikatowy', value: 'certificate' },
  kids: { id: 5, label: 'Dla dzieci', value: 'kids' },
  individual: { id: 6, label: 'Indywidualny', value: 'individual' }
}
